import moment from "moment";
import React, { memo, useEffect, useRef } from "react";
import { DateTimePicker } from "react-widgets";

import { InnodomDateFormats, WorkbenchDateFormats } from "@common/util/dateFormats";
import {
  DateTaxonomyEntry,
  DateTimeTaxonomyEntry,
  TaxonomyEntryType,
  TimeTaxonomyEntry,
} from "../../types";
import { InputComponentProps } from "./common";

const DateTimeInputComponent = ({
  active,
  dataPoint,
  id,
  onFocus,
  onUpdate,
  value,
}: InputComponentProps<
  DateTaxonomyEntry | DateTimeTaxonomyEntry | TimeTaxonomyEntry,
  string | undefined
>) => {
  const format =
    dataPoint.type in WorkbenchDateFormats
      ? WorkbenchDateFormats[dataPoint.type]
      : WorkbenchDateFormats.datetime;
  const currentValue = moment(value.value);
  const dateValue = currentValue.isValid() ? currentValue.toDate() : undefined;
  const focusRef = useRef<any>(null);
  useEffect(() => {
    if (!focusRef.current) {
      return;
    }
    if (active && focusRef.current.focus) {
      focusRef.current.focus();
    } else if (focusRef.current.blur) {
      focusRef.current.blur();
    }
  }, [active]);
  return (
    <>
      <DateTimePicker
        date={
          dataPoint.type === TaxonomyEntryType.Date || dataPoint.type === TaxonomyEntryType.DateTime
        }
        format={format}
        id={id}
        onChange={(date?: Date) => {
          let dateFormat = InnodomDateFormats.datetime;
          if (dataPoint.type in InnodomDateFormats) {
            dateFormat = InnodomDateFormats[dataPoint.type];
          }
          const momentDate = moment(date);
          onUpdate(id, momentDate.toString(), momentDate.format(dateFormat));
        }}
        onFocus={() => {
          onFocus(id);
        }}
        max={
          dataPoint.type === TaxonomyEntryType.Date || dataPoint.type === TaxonomyEntryType.DateTime
            ? dataPoint.max
            : undefined
        }
        min={
          dataPoint.type === TaxonomyEntryType.Date || dataPoint.type === TaxonomyEntryType.DateTime
            ? dataPoint.min
            : undefined
        }
        parse={str => {
          const parsed = moment(str, WorkbenchDateFormats.allSupported);
          if (parsed.isValid()) {
            return parsed.toDate();
          }
          setTimeout(() => {
            onUpdate(id, undefined, "");
          }, 0);
          return new Date();
        }}
        placeholder={format.replace(/\\/g, "")}
        ref={focusRef}
        time={
          dataPoint.type === TaxonomyEntryType.Time || dataPoint.type === TaxonomyEntryType.DateTime
        }
        value={dateValue}
      />
    </>
  );
};
DateTimeInputComponent.displayName = "DateTimeInput";
export const DateTimeInput = memo(DateTimeInputComponent);
